
import Main from "@/views/Main.vue";
const customerRoutes = [
  {
    path: "/specialCounter",
    icon: "grid",
    name: "specialCounter",
    title: "专柜自动补库",
    component: Main,
    children: [
      {
        //自动补库商家名单
        path: "storeManage",
        title: "自动补库商家名单",
        name: "storeManage",
        component: () => import( /* webpackChunkName:"specialCounter" */ "@/views/specialCounter/storeManage/index.vue")
      },
      {
        //自动补库商品黑名单
        path: "blacklist",
        title: "自动补库商品黑名单",
        name: "blacklist",
        component: () => import( /* webpackChunkName:"specialCounter" */ "@/views/specialCounter/blacklist/index.vue")
      },
      {
        //自动补库商品黑名单
        path: "storeManage/config",
        title: "自动补充库存数量",
        name: "storeManageConfig",
        component: () => import( /* webpackChunkName:"specialCounter" */ "@/views/specialCounter/storeManage/config.vue")
      },
  
    ]
  },
]

export default customerRoutes
